import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesLensItemsResponseModel } from '@/types/clarityLens'

export const getSalesLensItems = async (
  branchName: string,
  startDate: string,
  endDate: string,
  subSubCategory: string
): Promise<SalesLensItemsResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/daily-sales-lens/items`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
        sub_sub_category: subSubCategory,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
